<template>
  <el-dialog
    title="回访" custom-class="medium-dialog" center :close-on-click-modal="false" :append-to-body="true" :visible.sync="dialogVisible" >
    <el-form :model="form" ref="form1">
      <el-form-item label="联系方式" label-width="120" prop="reason" size="small">
        <span style="margin-right: 50px;font-size: x-large">{{row.linkman}}</span> <span style="margin-right: 50px;font-size: x-large">{{row.linkmantel}}</span>
        <span v-if="row.wxopenid" style="color: #20A0FF"><b>（已关注公众号）</b></span>
      </el-form-item>
      <el-form-item label="回访情况" label-width="120" prop="reason" size="small">
        <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10}" v-model="form.reason" auto-complete="off"></el-input>
      </el-form-item>
    </el-form>
    <iframe :src="iframeurl" class="framestyle" frameborder="0" scrolling="no" name="showsellframe"></iframe>
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="save" v-if="canedit">确 定</el-button>
    </span>
  </el-dialog>
</template>


<script>
  import {returnData} from '@/api/set/externaldept';
  import {orderView} from '@/api/order/shopping';

  export default {
    name: "ReasonDialog",
    data() {

      return {
        dialogVisible: false,
        iframeurl:'',
        canedit:false,
        form: {
          reason: ''
        },
        row: {},
      }
    },
    methods: {
      show(row) {
        this.dialogVisible = true;
        this.canedit=true;
        this.form.reason=''
        this.row = row;
        this.iframeurl = orderView({groupguid: row.unitguid});
      },
      showView(row){
        this.dialogVisible = true;
        this.canedit=false;
        this.form.reason=row.yecontent;
        this.row = row;
        this.row.linkman=row.uname;
        this.row.linkmantel=row.uguid;
        this.iframeurl = orderView({groupguid: row.yeunitguid});
      },
      save() {
        if (!this.form.reason) {
          this.$message({
            type: 'error',
            message: '请填写回访情况'
          });
          return;
        }
        let obj = {
          customerserial: this.row.customerserial,
          groupguid: this.row.unitguid,
          erpserial: this.row.erpserial,
          applybydname:this.row.applybydname,
          wxopenid:this.row.wxopenid?this.row.wxopenid:'',
          mobile: this.row.linkmantel,
          name: this.row.linkman,
          reason: this.form.reason
        }
        returnData({text: JSON.stringify(obj)}).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.dialogVisible = false;
            //刷新列表
            this.$emit('bindGrid');
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      }
    },
    mounted() {
    },
    components: {}
  }
</script>


<style scoped>
  .framestyle {
    width: 100%;
    border: 0px;
    height: 500px;
    background-size: 100% 100%;
    margin: 0px;
    padding: 0px;
  }
</style>




// WEBPACK FOOTER //
// src/components/workflow/waitaudit/ReasonDialog.vue